export default "__VITE_ASSET__C0U_LPCm__"